import React, { FunctionComponent, ComponentPropsWithoutRef, Fragment } from 'react';

export type TabItemProps = ComponentPropsWithoutRef<'div'>;

/**
 * This component acts as a wrapper for tabbed content, so that labels and values for
 * tabs can be provided on the parent of the content that is shown with each active tab.
 * The labels and values are read and used by the parent Tabs component.
 *
 * Values are optional to support future grouped tab items. The values are otherwise
 * inferred from the index of each item in the array of children.
 */
const MarkdownTabItem: FunctionComponent<React.PropsWithChildren<TabItemProps>> = ({
  children,
}) => {
  return <Fragment>{children}</Fragment>;
};

export default MarkdownTabItem;
MarkdownTabItem.displayName = 'TabItem';
